import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Enterprise systems I've built and shipped at{" "}
          <strong className="purple">Sopra Banking Software</strong>. Code for
          these lives in private company repositories.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={6} className="project-card">
            <ProjectCard
              isBlog={false}
              title="Metadata Platform"
              tag="Java · Spring Boot · Hibernate · SQL · Microservices · Docker"
              description="Full-stack CRUD framework acting as a wrapper around internal databases, eliminating direct DB changes and improving data integrity by 100%. Integrated with internal microservices to cut integration defects by 40%, plus led performance work that improved application stability by 25%."
            />
          </Col>

          <Col md={6} className="project-card">
            <ProjectCard
              isBlog={false}
              title="SBS AI Engineering Hub"
              tag="Java · Spring Boot · React.js · Docker · GitLab CI/CD · Azure OpenAI · Redis"
              description="Full-stack AI-powered developer hub that automates documentation generation, Jira subtask/epic creation, code suggestions, and AI chat support. Cut development turnaround time by 25% and new-developer onboarding time by 35%, built on a Spring Boot + React.js stack shipped via a Dockerized GitLab CI/CD pipeline."
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
